const RegistrationRecord = () => import('@/pages/k12/RegistrationRecord.vue');
const RegistList = () => import('@/pages/k12/RegistList.vue');
const ImportRegistList = () => import('@/pages/k12/ImportRegistList.vue');

export default [
	{ path: '/RegistrationRecord', name: 'RegistrationRecord', component: RegistrationRecord },
	{ path: '/RegistList', name: 'RegistList', component: RegistList },
	{ path: '/ImportRegistList', name: 'ImportRegistList', component: ImportRegistList },
];
